export default {
  drawerTitle: {
    id: 'review-photos-guidance-drawer-title',
    defaultMessage: 'Condition photos',
  },
  titlePremium: {
    id: 'review-photos-guidance-title-premium',
    defaultMessage: 'What Premium condition looks like',
  },
  titleFlawless: {
    id: 'review-photos-guidance-title-flawless',
    defaultMessage: 'What Excellent condition looks like',
  },
  titleVeryGood: {
    id: 'review-photos-guidance-title-very-good',
    defaultMessage: 'What Good condition looks like',
  },
  titleEco: {
    id: 'review-photos-guidance-title-eco',
    defaultMessage: 'What Fair condition looks like',
  },
  exampleTagPremium: {
    id: 'review-photos-guidance-example-tag-premium',
    defaultMessage: 'Example of Premium condition (body, screen)',
  },
  exampleTagFlawless: {
    id: 'review-photos-guidance-example-tag-flawless',
    defaultMessage: 'Example of Excellent condition (body, screen)',
  },
  exampleTagVeryGood: {
    id: 'review-photos-guidance-example-tag-very-good',
    defaultMessage: 'Example of Good condition (body, screen)',
  },
  exampleTagEco: {
    id: 'review-photos-guidance-example-tag-eco',
    defaultMessage: 'Example of Fair condition (body, screen)',
  },
  subtitle: {
    id: 'review-photos-guidance-subtitle',
    defaultMessage: 'Photos from verified reviews',
  },
  alternativeNext: {
    id: 'review-photos-guidance-next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'review-photos-guidance-previous',
    defaultMessage: 'Previous',
  },
  tabPremium: {
    id: 'review-photos-guidance-tab-premium',
    defaultMessage: 'Premium',
  },
  tabFlawless: {
    id: 'review-photos-guidance-tab-flawless',
    defaultMessage: 'Excellent',
  },
  tabVeryGood: {
    id: 'review-photos-guidance-tab-very-good',
    defaultMessage: 'Good',
  },
  tabEco: {
    id: 'review-photos-guidance-tab-eco',
    defaultMessage: 'Fair',
  },
  tabsLabel: {
    id: 'review-photos-guidance-tabs-label',
    defaultMessage: 'Reviews photos by condition',
  },
  carouselController: {
    id: 'review-photos-guidance-carousel-controller',
    defaultMessage: 'Photo carousel controller',
  },
  defaultCardDescriptionPremium: {
    id: 'review-photos-guidance-default-card-description-premium',
    defaultMessage:
      'This is an example of a Premium condition product. Browse photos from verified reviews to see what this condition looks like.',
  },
  defaultCardDescriptionFlawless: {
    id: 'review-photos-guidance-default-card-description-flawless',
    defaultMessage:
      'This is an example of an Excellent condition product. Browse photos from verified reviews to see what this condition looks like.',
  },
  defaultCardDescriptionVeryGood: {
    id: 'review-photos-guidance-default-card-description-very-good',
    defaultMessage:
      'This is an example of a Good condition product. Browse photos from verified reviews to see what this condition looks like.',
  },
  defaultCardDescriptionEco: {
    id: 'review-photos-guidance-default-card-description-eco',
    defaultMessage:
      'This is an example of a Fair condition product. Browse photos from verified reviews to see what this condition looks like.',
  },
}
